/**
 * BOGO Promotion Component
 * Singleton pattern - only initializes once even if script loads multiple times
 */
(function() {
  // Check if already initialized
  if (window.bogoPromotionInitialized) {
    return;
  }
  window.bogoPromotionInitialized = true;

  class BogoPromotion extends HTMLElement {
    constructor() {
      super();
      this.cartUpdateUnsubscriber = null;
    }

    connectedCallback() {
      //this.setupBogoQualification();
      this.subscribeToCartUpdates();
    }

    disconnectedCallback() {
      this.cartUpdateUnsubscriber?.();
    }
    renderBogoBlock() {
      const sectionId = this.closest('[data-section-id]')?.dataset.sectionId;

      if (!sectionId) return;

      fetch(`${window.location.pathname}?section_id=${sectionId}`)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newBlocks = Array.from(doc.querySelectorAll('[data-bogo-promotion]'));
          
          // Get all current blocks on the entire page with data-bogo-promotion
          const currentBlocks = Array.from(document.querySelectorAll('[data-bogo-promotion]'));
          
          // Update all blocks by index - just replace innerHTML
          newBlocks.forEach((newBlock, index) => {
            const currentBlock = currentBlocks[index];
            if (newBlock && currentBlock) {
              currentBlock.innerHTML = newBlock.innerHTML;
            }
          });
        })
        .catch(error => console.error('BOGO: Render failed:', error));
    }
    setupBogoQualification() {
      
     
      const bogoScript = document.querySelector('script[data-bogo-item]');
       
      if (!bogoScript) return;
    
      
      try {
        const itemData = JSON.parse(bogoScript.textContent);
        itemData.properties = Array.isArray(itemData.properties) 
            ? itemData.properties.reduce((acc, [key, value]) => (acc[key] = value, acc), {})
            : itemData.properties || {};
        
        if (itemData && !itemData.properties?.['_bogo_qualified']) {
          
        
          itemData.properties['_bogo_qualified'] = 'true';
         
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: itemData.id,
              quantity: itemData.quantity,
              properties: itemData.properties
            })
          
            
          })
          .then(res => res.json())
    .then(cart => {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'bogo-promotion',
          cart
        });
      }
    })
    .catch(error => {
            console.error('BOGO: Cart change error:', error);
          });
        }
      } catch (error) {
        console.error('BOGO: Qualification failed:', error);
      }
    }

    subscribeToCartUpdates() {
      const isCartPage = window.location.pathname.startsWith('/cart');

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {

          if (event.source !== 'bogo-promotion' && !isCartPage) {
            this.renderBogoBlock();
          }
        });
      }
    }

    

    refresh() {
      this.renderBogoBlock();
    }
  }

  // Only define custom element if not already defined
  if (!customElements.get('bogo-promotion')) {
    customElements.define('bogo-promotion', BogoPromotion);
  }
})(); 